import deleteNulls from '~/utils/deleteNulls';

import cleanProperty from './cleanProperty';

export const propertyKeysToDeleteIfNull = [
  'hotel_meta_provider',
  'pms',
  'max_teenager_age',
  'auto_luxplus_margin_threshold',
  'auto_luxplus_min_discount',
  'auto_luxplus_max_discount',
  'auto_luxplus_max_nightly_discount',
];

export function sanitizePropertyForTaxesContentUpdate(property) {
  return cleanProperty(deleteNulls(property, propertyKeysToDeleteIfNull));
}
